import 'product/form'
import 'product/ask'
import 'product/slider'
import 'product/terms'
import 'global/sharing'
import 'product/bookmark'